import FinanceAdapter from './base';

export default class Debtor extends FinanceAdapter {
  namespace = 'finance/v4/reports';
  modelNamePlural = 'debtors';
}
